import React from "react";
import { NavLink } from "react-router-dom";

import styles from "./sectionTabs.module.scss";

/**
 * The tab bar over a page that belongs to a tabbed nav group (AI, User
 * Interactions). Rendered by the layout rather than by each page, so a page
 * added to the group in navSections.js gets its tab with nothing else to
 * remember.
 *
 * Tabs are links, not local state: each tab is its own route, so the address
 * bar, the back button and a shared link all land on the right one.
 *
 * `group.children` arrives already filtered by permission — a tab only exists
 * for a page this admin can open.
 */
const SectionTabs = ({ group }) => (
  <nav className={styles.bar} aria-label={group.name}>
    {group.children.map((child) => {
      const Icon = child.icon;
      return (
        <NavLink
          key={child.path}
          to={child.path}
          end={child.end}
          className={({ isActive }) =>
            `${styles.tab} ${isActive ? styles.active : ""}`
          }
        >
          {Icon && <Icon size={16} strokeWidth={2} aria-hidden />}
          <span>{child.name}</span>
        </NavLink>
      );
    })}
  </nav>
);

export default SectionTabs;
